var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-swatches',{attrs:{"value":_vm.value,"show-fallback":"","swatches":_vm.field.items.map(c => c.color),"fallback-input-type":"color","popover-x":"left"},on:{"input":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }